// extracted by mini-css-extract-plugin
export default {"cards":"Usuarios_cards__Dfiej"};